import { env } from "configs/EnvironmentConfig";
import { ALL_BU } from "constants/DashboardContanst";
import fetch from "../auth/FetchInterceptor";

const invoiceSymbolService = {};

// List Invoice Symbol
invoiceSymbolService.listInvoiceSymbol = (
  { params },
  bu_code,
  isListManager = false
) => {
  const columnFilter = params.columnFilter || {};
  const defaultFields = [
    // "id",
    // "khmhdon",
    // "khhdon",
    // "bu_code",
    // "template_doc",
    // "invoice_type",
    // "maker_id",
    // "maker_date",
    // "checker_id",
    // "checker_date",
    // "record_status",
    // "tenant_code",
    // "is_pos",
  ];

  return fetch({
    url: `${env.API_MSP}/notations`,
    method: "get",
    params: {
      "filter[is_pos]": isListManager ? undefined : 0,
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "",
      fields: params.fields || defaultFields.join(","),
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
    },
  });
};

// Create Invoice Symbol
invoiceSymbolService.createInvoiceSymbol = ({ data }) => {
  return fetch({
    url: `${env.API_MSP}/notations`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Detail Invoice Symbol
invoiceSymbolService.detailInvoiceSymbol = ({ invoiceSymbolId, params }) => {
  const defaultFields = [
    // "id",
    // "khmhdon",
    // "khhdon",
    // "bu_code",
    // "record_status",
    // "tenant_code",
    // "is_pos",
  ];

  return fetch({
    url: `${env.API_MSP}/notations/${invoiceSymbolId}`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || "",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// Update Invoice Symbol
invoiceSymbolService.updateInvoiceSymbol = ({ invoiceSymbolId, data }) => {
  return fetch({
    url: `${env.API_MSP}/notations/${invoiceSymbolId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// Delete Invoice Symbol
invoiceSymbolService.deleteInvoiceSymbol = ({ invoiceSymbolId }) => {
  return fetch({
    url: `${env.API_MSP}/notations/${invoiceSymbolId}`,
    method: "delete",
  });
};

// Active Invoice Symbol
invoiceSymbolService.activeInvoiceSymbol = ({ invoiceSymbolId, data }) => {
  return fetch({
    url: `${env.API_MSP}/notations/${invoiceSymbolId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

export default invoiceSymbolService;
